<template>
  <v-row align="center" justify="center">
    <v-col cols="12" sm="8" md="8" lg="6" xl="4">
      <v-card class="elevation-12 pa-9">
        <v-container>
          <v-row class="mt-1 mb-5" justify="center">
            <div>
              <v-toolbar-title v-if="this.$route.query.regist" class="wrap-text">
                講座登録のためにはサインインが必要です
              </v-toolbar-title>
              <v-toolbar-title v-else class="wrap-text">
                PlatJaMにサインイン
              </v-toolbar-title>
            </div>
          </v-row>
          <v-row class="text-center">
            <v-col>
              <LoginWithGoogleHostUi />
            </v-col>
          </v-row>
          <br />
          <v-divider />
          <br />
          大学・企業ユーザの方は以下からサインインしてください
          <v-row>
            <v-col>
              <login-with-cognito
                class="pa-3"
                @success="afterSignIn"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import axios from 'axios'
import store from '@/store/store'
import repository from '@/store/repository'
import handleApiError from '@/plugins/handleApiError'

import LoginWithCognito from '@/components/pages/signIn/LoginWithCognito.vue'
import LoginWithGoogleHostUi from '@/components/pages/signIn/LoginWithGoogleHostUi.vue'

export default {
  components: {
    LoginWithCognito,
    LoginWithGoogleHostUi
  },
  data () {
    return {
      res: null
    }
  },
  methods: {
    async afterSignIn () {
      let status = null
      // もし query に講座登録情報があれば登録する
      if (this.$route.query.regist || store.state.registCourseId) {
        await this.registerCourse(store.state.registCourseId)
        if (this.res === 2) {
          status = false
        } else {
          status = true
        }
        repository.removeRegistCourseId()
      }

      // ログイン後のURLを固定しない場合以下のコードに差し替え
      // const dest = this.$route.query.redirect || '/'
      if (status !== null) {
        this.$router.push({ name: 'Registered', params: { registStatus: status } })
      } else {
        this.$router.push({ name: 'CourseList' })
      }
    },

    async registerCourse (courseId) {
      const reqUrl = process.env.VUE_APP_COURSE_REGISTRATION_API_URL

      const reqBody = {
        pjmUserId: String(repository.getPjmUserId()),
        cognitoIdToken: repository.getIdToken(),
        cognitoUsername: store.state.username,
        courseId: courseId
      }
      const header = {
        headers: {
          'x-api-key': process.env.VUE_APP_DB_API_KEY,
          'Content-Type': 'application/json',
          Authorization: repository.getAccessToken()
        }
      }

      // 講座登録API を叩く
      const result = await axios.post(reqUrl, reqBody, header).catch(handleApiError)
      this.res = result.data.registResult
    }
  }
}
</script>
